import cx from "classnames";
import { type FC, type ReactNode } from "react";

export type EmptyStateProps = {
	icon?: ReactNode;
	headline?: string;
	children?: ReactNode;
};

export const EmptyState: FC<EmptyStateProps> = ({ icon, headline, children }) => {
	const Icon = icon ? (
		<div
			style={{ width: "112px", height: "112px" }}
			className="flex items-center justify-center rounded-full border"
		>
			{icon}
		</div>
	) : null;

	const Headline = headline ? (
		<div>
			<h1 className="text-secondary text-lg font-normal">{headline}</h1>
		</div>
	) : null;

	const Content = <div>{children}</div>;

	return (
		<div
			className={cx(
				"flex",
				"grow",
				"h-full",
				"w-full",
				"flex-col",
				"items-center",
				"justify-center",
				"p-4",
				"gap-8"
			)}
		>
			{Icon}
			{Headline}
			{Content}
		</div>
	);
};
